import React from 'react';
import { Controller, type FieldErrors } from 'react-hook-form';
import { Input } from '@planne-software/uni/Input';

import { useTranslate } from '@src/core/hooks';

import { maskCardValidity, maskSecurityCode } from '../core/cardFieldMasks';
import type { CardFormValues } from '../core/cardPaymentFormSchema';
import type { CardFormVisibility } from '../core/resolveCardFormVisibility';
import type { CardFormControl } from '../types';
import { Grid } from '@planne-software/uni/Grid';

import { cardFieldSize } from '../styles';

type CardSecurityFieldsProps = {
  control: CardFormControl;
  errors: FieldErrors<CardFormValues>;
  visibility: CardFormVisibility;
  disabled: boolean;
};

export const CardSecurityFields = (props: CardSecurityFieldsProps) => {
  const { control, errors, visibility, disabled } = props;
  const { i18n } = useTranslate();

  return (
    <>
      <Grid size={cardFieldSize()} data-testid='card-form-validity'>
        <Controller
          name='validity'
          control={control}
          render={({ field: { ref, ...field } }) => (
            <Input
              {...field}
              id={field.name}
              inputRef={ref}
              label={i18n('checkout_valid_date')}
              required
              mask={maskCardValidity}
              placeholder={i18n('direct_link_card_form_validity_placeholder')}
              inputMode='numeric'
              autoComplete='cc-exp'
              disabled={disabled}
              disableClearable
              error={!!errors.validity}
              helperText={errors.validity?.message}
              size='medium'
            />
          )}
        />
      </Grid>

      <Grid size={cardFieldSize(visibility.securityCodeSpan)} data-testid='card-form-security-code'>
        <Controller
          name='securityCode'
          control={control}
          render={({ field: { ref, ...field } }) => (
            <Input
              {...field}
              id={field.name}
              inputRef={ref}
              label={i18n('checkout_payment_card_security_code')}
              required
              mask={maskSecurityCode}
              inputMode='numeric'
              autoComplete='cc-csc'
              disabled={disabled}
              disableClearable
              error={!!errors.securityCode}
              helperText={errors.securityCode?.message}
              size='medium'
            />
          )}
        />
      </Grid>
    </>
  );
};

export default CardSecurityFields;
